export default __webpack_public_path__ + "static/media/bill.91faddf6.jpeg";